/* This is the api domain */

//export const apiConfig = "https://test.levven.ixia.tech:8444/backend";
//export const apiConfig = "http://localhost:4000";
//export const apiConfig = "https://test-avenue.levven.com/backend";
export const apiConfig = "https://avenue.levven.com/backend";

